export const environment = {
    production: false,
    apiKey: 'InT$aP3_i*v5S+a=O41qPmz19+jh~uipq_fI',
    //apiUrl: 'http://localhost:5065/api/'
    apiUrl: 'https://service-applicationlog-api-dev.tesvolt.com/api/',
    msalConfig: {
        auth: {
            clientId: 'a947cab1-479d-4ae6-90b6-0a1f31eb375a',
            authority: 'https://login.microsoftonline.com/277d78b9-3554-43f8-ba8f-31eac2bd4dcc',
            //redirectUri: 'http://localhost:4200/'
            redirectUri: 'https://applicationlog-dev.tesvolt.com/'
        },
    },
    apiConfig: {
        scopes: ['user.read'],
        uri: 'https://graph.microsoft.com/v1.0/me',
    },    
};